import { render } from "./InputCheckbox.vue?vue&type=template&id=35fdacb7"
import script from "./InputCheckbox.vue?vue&type=script&lang=js"
export * from "./InputCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__